<template>
    <div class="post__categories">

        <div class="post__aside-heading">
            Categories
        </div>

        <div class="post__categories-body blog__latest-categories d-flex flex-wrap pt-3">
            <category-item
                v-for="category in categories"
                :key="category.slug"
                :category="category"
            />
        </div>

    </div>
</template>

<script>

import CategoryItem from '../LatestCategoryItem'

export default {
    name: "PostCategories",
    components: { CategoryItem },
    props: {
        categories: { required: true, type: Array }
    }
}
</script>

<style>

</style>
